import { createSelector } from 'reselect'

const getState = state => state.settings
const swipeFirstLook = state => getState(state).swipeFirstLook

const isSwipeFirstLookSelector = createSelector(
  swipeFirstLook,
  swipeFirstLook => swipeFirstLook
)

const settingsSelectors = {
  isSwipeFirstLookSelector
}

export default settingsSelectors
